import { HomePageData } from "@/interfaces/site-settings.interface";
import { getSiteContent } from "@/utils/apis/site-settings/site-settings.api";
import Home from "./home";

export default function HomePage({ serverPageData }: { serverPageData: HomePageData | null }) {
  return (
    <>
      <main>
        <Home serverPageData={serverPageData} />
      </main>
    </>
  );
}

export const getServerSideProps = async () => {
  let serverPageData = null;
  try {
    const res = await getSiteContent("homePage");
    if (res?.data?.success) {
      serverPageData = res?.data?.data;
    }
  } catch (error) {
    console.log("<getServerSideProps Index> Error", error);
  }

  return {
    props: {
      serverPageData,
    },
  };
};
